export default {
  about: {
    zh: '关于',
    en: 'About',
    ja: 'MQTTXについて',
  },
  update: {
    zh: '检查更新',
    en: 'Check for Updates',
    ja: 'バージョンチェック',
  },
  web: {
    zh: '官方网站',
    en: 'Website',
    ja: '公式サイト',
  },
  support: {
    zh: '支持',
    en: 'Support',
    ja: 'サポート',
  },
  releases: {
    zh: '更新日志',
    en: 'Releases',
    ja: 'リリース履歴',
  },
  mqttxDesc: {
    zh: 'MQTTX Web 是一款开源的可在浏览器运行的 MQTT 5.0 WebSocket 客户端工具，无需本地安装即可帮助您更快地调试 MQTT 服务及应用。',
    en: 'MQTTX Web is an open-source MQTT 5.0 WebSocket client on the browser to help you debug your MQTT services and applications faster.',
    ja: 'MQTTX Webは、オープンソースのMQTT 5.0 WebSocketクライアントで、ブラウザ上でMQTTサービスやアプリケーションのデバッグを高速化することができます。',
  },
  cloudTitle: {
    zh: '立即获取一个您专属的 MQTT 服务！',
    en: 'Get Your Dedicated MQTT Server Now!',
    ja: '専用のMQTTサーバーを今すぐご利用いただけます！',
  },
  cloudSummary: {
    zh: '发掘物联网的强大能量，尝试使用 EMQX Cloud - 一款全托管的 MQTT 云服务平台，支持连接海量设备，使用灵活按量计费的方式实时处理数据，将物联网连接和数据处理变得更高效便捷。',
    en: 'Unlock the power of IoT with EMQX Cloud - the fully managed MQTT cloud service platform that connects massive amounts of devices and processes real-time data with flexible pay-per-use billing.',
    ja: 'EMQX Cloudを使用してIoTの強力な機能を発見しましょう。EMQX Cloudは、大規模なデバイスを接続し、リアルタイムデータを柔軟な使用料金で処理することができる完全に管理されたMQTTクラウドサービスプラットフォームです。',
  },
  tryCloud: {
    zh: '免费试用 EMQX Cloud',
    en: 'Try EMQX Cloud for free',
    ja: 'EMQX Cloudの無料体験',
  },
}
